<template lang="pug">
div
  b-card
    .row
      .col-md-12
        .white-box
          h1.box-title.m-b-0 FAQ編集
          p.text-muted.m-b-30.font-13 SWAN ProサイトのFAQ編集画面
          div.form-horizontal
            .form-group
              label.col-md-12 言語
              .col-md-12
                el-select(v-model='entryData.locale', disabled='')
                  el-option(value='ja', label='日本語')
                  el-option(value='en', label='英語')
                  el-option(value='cn', label='中国語')
                  el-option(value='kr', label='韓国語')
            .form-group
              label(for='他の言語').col-md-12 他の言語 
              .col-md-12
                a(v-if="entryData.locale!='ja'" :href='locale_url.ja' replace) 日本語&nbsp;&nbsp;
                a(v-if="entryData.locale!='en'" :href='locale_url.en' replace) 英語&nbsp;&nbsp;
                a(v-if="entryData.locale!='cn'" :href='locale_url.cn' replace) 中国語&nbsp;&nbsp;
                a(v-if="entryData.locale!='kr'" :href='locale_url.kr' replace) 韓国語&nbsp;&nbsp;
            .form-group
              label.col-md-12 タイトル
              .col-md-12
                el-input#faqTitle(type='text', v-model='entryData.title')
            .form-group
              label.col-md-12 サブタイトル
              .col-md-12
                el-input#faqSubtitle(type='text', v-model='entryData.subtitle')
            .form-group
              label.col-md-12 本文（答え）
              .col-md-12
                el-input#faqAnswer(type='textarea', :rows='5', v-model='entryData.answer')
            .form-group
              label.col-md-12 カテゴリー
              .col-md-12
                el-select#faqCategory(v-model='entryData.category_name')
                  el-option(value='スワン本体', label='スワン本体')
                  el-option(value='スコッチガン', label='スコッチガン') 
                  el-option(value='ワンカップシステム', label='ワンカップシステム')
                  el-option(value='制御盤', label='制御盤')
                  el-option(value='コ・スワン', label='コ・スワン')
                  el-option(value='その他', label='その他')
            .form-group(v-if='imageLength > 0')
              label.col-md-12 登録済み画像・動画
              .col-md-12
                el-table(:data='entryData.images')
                  el-table-column(label="image", width="300")
                    template(slot-scope="scope")
                      img(v-if='scope.row.file_type=="image"', :src='scope.row.image_url', height='128')
                      video(v-if='scope.row.file_type=="video"', :src='scope.row.image_url', height='128')
                  el-table-column(property='image_url', label='image_url', width='200')
                  el-table-column(label='caption')
                    template(slot-scope='scope')
                      el-input(v-model='scope.row.caption', placeholder='キャプション')
                  el-table-column(label='Operations', width='200')
                    template(slot-scope='scope')
                      el-button(size='mini', type='primary', icon='el-icon-caret-top', circle, @click='moveImgUp(scope.$index)')
                      el-button(size='mini', type='primary', icon='el-icon-caret-bottom', circle, @click='moveImgDown(scope.$index)')
                      el-button(size='mini', type='danger', icon='el-icon-delete', @click='deleteImage(scope.$index, "mainImage")') 
            .form-group
              span.col-md-12 画像・動画
              el-button(type='primary', icon='el-icon-plus', size='mini', @click='onBtnFileAdd')
              .col-md-12
                el-table(:data='entryData.uploadedImages')
                  el-table-column(label='image', width='300')
                    template(slot-scope='scope')
                      img(v-if='scope.row.file_type=="image"', :src='scope.row.image', height='128')
                      video(v-if='scope.row.file_type=="video"', :src='scope.row.image', height='128')
                  el-table-column(property='name', label='name', width='200')
                  el-table-column(label='caption')
                    template(slot-scope='scope')
                      el-input(v-model='scope.row.caption', placeholder='キャプション')
                  el-table-column(label='', width='200')
                    template(slot-scope='scope')
                      el-button(size='mini', type='primary', icon='el-icon-caret-top', circle, @click='moveNewImgUp(scope.$index)')
                      el-button(size='mini', type='primary', icon='el-icon-caret-bottom', circle, @click='moveNewImgDown(scope.$index)')
                      el-button(size='mini', type='danger', icon='el-icon-delete', @click='deleteImage(scope.$index, "uploadedImage")') 
                input#btnFileAdd(type='file', style='visibility: hidden', @change='onFileAdd($event)')
  .card
    .col-md-12
      publicSetting(apiname='faq', :formdata='entryData')

</template>

<script>
import axios from 'axios'
import moment from 'moment'
import PublicSetting from '@/views/components/swan/common/PublicSetting'

export default {
  name: 'FaqEdit',
  data () {
    return {
      locale_url: {
        ja: '',
        en: '',
        cn: '',
        kr: ''
      },
      entryData: {
        entry_id: '',
        locale: '',
        title: '',
        subtitle: '',
        answer: '',
        images: [],
        uploadedImages: [],
        ordered: '',
        category_name: '',
        open_date: '',
        close_date: '',
        created_at: '',
        updated_at: '',
        status: '',
        agree_list: [],
        agree_user: '',
        waiting: false
      },
      imageLength: Number
    }
  },
  created () {
    moment.locale('ja')
    this.imageLength = 0
    if (this.$route.query.id && this.$route.query.locale) {
      this.getEntry(this.$route.query.id, this.$route.query.locale)
    } else {
      this.entryData.locale = 'ja'
    }
    this.locale_url.ja = '?id=' + this.$route.query.id + '&locale=ja'
    this.locale_url.en = '?id=' + this.$route.query.id + '&locale=en'
    this.locale_url.cn = '?id=' + this.$route.query.id + '&locale=cn'
    this.locale_url.kr = '?id=' + this.$route.query.id + '&locale=kr'
  },
  components: {
    PublicSetting
  },
  methods: {
    getEntry (id, locale) {
      return axios({
        method: 'GET',
        baseURL: process.env.API_BASE_URL,
        // url: '/admin/swan/faq/edit?entry_id=' + this.$route.query.id + '&locale=' + this.$route.query.locale
        url: '/admin/swan/faq/edit?entry_id=' + id + '&locale=' + locale
      })
        .then((res) => {
          if (Object.keys(res.data).length) {
            let content = res.data
            this.imageLength = content.images.length
            content.locale = locale
            content.entry_id = id
            content.created_at = moment(content.created_at).format('YYYY-MM-DD HH:mm')
            content.updated_at = moment(content.updated_at).format('YYYY-MM-DD HH:mm')
            if (content.open_at) {
              content.open_date = moment(content.open_at).format('YYYY-MM-DD')
              content.open_time = moment(content.open_at).format('HH:mm')
            } else {
              content.open_date = null
              content.open_time = null
            }
            if (content.close_at) {
              content.close_date = moment(content.close_at).format('YYYY-MM-DD')
              content.close_time = moment(content.close_at).format('HH:mm')
            } else {
              content.close_date = null
              content.close_time = null
            }
            content.uploadedImages = []
            this.entryData = content
          } else {
            this.entryData.entry_id = id
            this.entryData.locale = locale
          }
        })
        .catch((error) => {
          // 暫定的に作成されていない別言語の記事作成に対応するために記事IDと言語情報を格納
          this.entryData.entry_id = id
          this.entryData.locale = locale
          console.log(error)
        })
    },
    deleteImage (index, imageType) {
      let imageName = ''
      let imageObject
      if (imageType === 'mainImage') {
        imageName = this.entryData.images[index].name !== undefined ? this.entryData.images[index].name : '画像'
        imageObject = this.entryData.images
      } else if (imageType === 'uploadedImage') {
        imageName = this.entryData.uploadedImages[index].name !== undefined ? this.entryData.uploadedImages[index].name : '画像'
        imageObject = this.entryData.uploadedImages
      }
      this.$confirm(imageName + 'を削除しますか？', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
        center: true
      }).then(() => {
        imageObject.splice(index, 1)
        this.$message({
          type: 'success',
          message: 'Delete completed'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete canceled'
        })
      })
    },
    moveImgUp (orgIndex) {
      if (orgIndex > 0) {
        let target = orgIndex - 1
        let tmp = this.entryData.images.filter((_, index) => index !== orgIndex)
        tmp.splice(target, 0, this.entryData.images[orgIndex])
        this.entryData.images = tmp
      }
    },
    moveImgDown (orgIndex) {
      if (orgIndex < this.entryData.images.length) {
        let target = orgIndex + 1
        let tmp = this.entryData.images.filter((_, index) => index !== orgIndex)
        tmp.splice(target, 0, this.entryData.images[orgIndex])
        this.entryData.images = tmp
      }
    },
    moveNewImgUp (orgIndex) {
      if (orgIndex > 0) {
        let target = orgIndex - 1
        let tmp = this.entryData.uploadedImages.filter((_, index) => index !== orgIndex)
        tmp.splice(target, 0, this.entryData.uploadedImages[orgIndex])
        this.entryData.uploadedImages = tmp
      }
    },
    moveNewImgDown (orgIndex) {
      if (orgIndex < this.entryData.uploadedImages.length) {
        let target = orgIndex + 1
        let tmp = this.entryData.uploadedImages.filter((_, index) => index !== orgIndex)
        tmp.splice(target, 0, this.entryData.uploadedImages[orgIndex])
        this.entryData.uploadedImages = tmp
      }
    },
    onBtnFileAdd (e) {
      document.getElementById('btnFileAdd').click()
    },
    onFileAdd (e) {
      let files = e.target.files || e.dataTransfer.files
      if (files[0].type.match(/image/i) || files[0].type.match(/video/i)) {
        let fileType = files[0].type.match(/image/i) ? 'image' : 'video'
        let reader = new FileReader()
        reader.onload = (r) => {
          this.entryData.uploadedImages.push({ name: files[0].name, image: r.target.result, caption: '', file_type: fileType })
        }
        this.imageCount++
        reader.readAsDataURL(files[0])
      } else {
        let msg = '画像ではありません'
        alert(msg)
      }
    }
  }
}
</script>

<style lang='scss' scoped>
*:focus {
  outline: 0
}
</style>


// WEBPACK FOOTER //
// src/views/components/swan/faq/edit.vue